var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF2Nsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 353.85 129.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bAlt",
    x1: 136.85,
    y1: -8.42,
    x2: 136.85,
    y2: 69.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cAlt",
    x1: 130.25,
    y1: -8.42,
    x2: 130.25,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAlt",
    x1: 168.27,
    y1: -8.42,
    x2: 168.27,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eAlt",
    x1: 222.09,
    y1: -8.42,
    x2: 222.09,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fAlt",
    x1: 228.68,
    y1: -8.42,
    x2: 228.68,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gAlt",
    x1: 179.47,
    y1: -8.42,
    x2: 179.47,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hAlt",
    x1: 190.66,
    y1: -8.42,
    x2: 190.66,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iAlt",
    x1: 264.28,
    y1: -8.42,
    x2: 264.28,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jAlt",
    x1: 94.83,
    y1: -8.42,
    x2: 94.83,
    y2: 69.32,
    xlinkHref: "#bAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kAlt",
    x1: 104.61,
    y1: 61.59,
    x2: 104.61,
    y2: 122.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lAlt",
    x1: 151.9,
    y1: 61.59,
    x2: 151.9,
    y2: 122.87,
    xlinkHref: "#kAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mAlt",
    x1: 193.48,
    y1: 61.59,
    x2: 193.48,
    y2: 122.87,
    xlinkHref: "#kAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nAlt",
    x1: 237.6,
    y1: 61.59,
    x2: 237.6,
    y2: 122.87,
    xlinkHref: "#kAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oAlt",
    x1: 286.49,
    y1: 61.59,
    x2: 286.49,
    y2: 122.87,
    xlinkHref: "#kAlt"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pAlt",
    x1: 333.79,
    y1: 61.59,
    x2: 333.79,
    y2: 122.87,
    xlinkHref: "#kAlt"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.03,53.26c-1.16,0-2.17-.81-2.34-1.93-.05-.34-.42-3.4,1.83-5.8,1.61-1.71,4-2.55,7.16-2.5.54,0,3.58-.02,6.79-.04,4.07-.03,8.69-.07,11.3-.07,5.6,0,8.18,1.67,10.75,3.69,1,.79,1.13,2.18.3,3.12-.84.94-2.32,1.06-3.32.28-2.11-1.66-3.68-2.66-7.73-2.66-2.59,0-7.2.04-11.26.07-3.91.03-6.33.05-6.91.04-1.16-.02-2.72.14-3.54.99-.86.89-.71,2.29-.71,2.3.18,1.21-.72,2.32-2.01,2.48-.11.01-.22.02-.32.02Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.78,45.21l-18.62.04c-6.23,0-11.29,4.86-11.29,10.61s4.21,13.97,4.21,13.97l32.77-.04s4.21-8.22,4.21-13.97-5.05-10.61-11.29-10.61Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.91,53.22c1.16,0,2.17-.81,2.34-1.93.05-.34.42-3.4-1.83-5.8-1.61-1.71-4-2.55-7.16-2.5-.54,0-3.58-.02-6.79-.04-4.07-.03-8.69-.07-11.3-.07-5.6,0-8.18,1.67-10.75,3.69-1,.79-1.13,2.18-.3,3.12.84.94,2.32,1.06,3.32.28,2.11-1.66,3.68-2.66,7.73-2.66,2.59,0,7.2.04,11.26.07,3.91.03,6.33.05,6.91.04,1.16-.02,2.72.14,3.54.99.86.89.71,2.29.71,2.3-.18,1.21.72,2.32,2.01,2.48.11.01.22.02.32.02Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.47,21.9c-17.99,0-39.99,2.87-36.26,14,1.12,3.33,6.83,6.48,8.15,5.57,1.31-.91-.48-2.06-1.97-3.67-6.02-6.44,9.76-8.79,13.12-9.23,3.34-.44,6.74-.59,10.11-.56,2.55.03,4.46,1.89,4.66,4.29.22,2.63.22,5.28.24,7.93,0,1.15.57,2.22,1.95,2.22s1.94-1.11,1.95-2.26c.02-2.64.02-5.29.24-7.93.2-2.4,2.11-4.26,4.66-4.29,3.37-.04,6.78.12,10.11.56,3.36.44,19.14,2.79,13.12,9.23-1.5,1.6-3.29,2.76-1.97,3.67,1.31.91,7.03-2.24,8.15-5.57,3.73-11.13-18.27-13.96-36.26-13.96Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.64,19.69h-23.29v-6.9h26.05s-2.76,2.35-2.76,6.9Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.11,39.39c-1.3,0-2.36-.99-2.36-2.22V12.28c0-1.22,1.06-2.22,2.36-2.22s2.36.99,2.36,2.22v24.9c0,1.22-1.06,2.22-2.36,2.22Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.3,19.65c1.49,0,23.29,0,23.29,0v-6.9s-26.05,0-26.05,0c0,0,2.76,2.35,2.76,6.9Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.82,39.35c-1.3,0-2.36-.99-2.36-2.22V12.23c0-1.22,1.06-2.22,2.36-2.22s2.36.99,2.36,2.22v24.9c0,1.22-1.06,2.22-2.36,2.22Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.37,70.3h-15.34c-1.3,0-2.36-.99-2.36-2.22s1.06-2.22,2.36-2.22h15.34c4.46,0,12.33-4.39,14.98-6.08,1.08-.69,2.54-.42,3.27.59.73,1.01.45,2.39-.63,3.08-1.1.7-10.93,6.85-17.63,6.85Z",
    fill: "url(#bAlt)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.05,61.78h-11.02c-1.3,0-2.36-.99-2.36-2.22s1.06-2.22,2.36-2.22h11.02c3.46,0,5.77-2.02,5.79-2.04.94-.85,2.43-.83,3.33.05.91.88.88,2.28-.05,3.13-.15.13-3.67,3.28-9.07,3.28Z",
    fill: "url(#cAlt)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.95,40.35s-6.55.02-7.36,1.22v-9.56s3.81-.77,5.7-.28,1.66,2.5,1.66,2.5v6.12Z",
    fill: "url(#dAlt)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.57,70.26h15.34c1.3,0,2.36-.99,2.36-2.22s-1.06-2.22-2.36-2.22h-15.34c-4.46,0-12.33-4.39-14.98-6.08-1.08-.69-2.54-.42-3.27.59-.73,1.01-.45,2.39.63,3.08,1.1.7,10.93,6.85,17.63,6.85Z",
    fill: "url(#eAlt)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.89,61.73h11.02c1.3,0,2.36-.99,2.36-2.22s-1.06-2.22-2.36-2.22h-11.02c-3.46,0-5.77-2.02-5.79-2.04-.94-.85-2.43-.83-3.33.05-.91.88-.88,2.28.05,3.13.15.13,3.67,3.28,9.07,3.28Z",
    fill: "url(#fAlt)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.91,0c-1.93,0-16.96.04-18.89.04-4.2,0-4.02,4.65.08,4.65,1.65,0,4.91,0,7.51,0,0,1.82-.03,3.47.01,5.12.02.86-.19,1.31-1.2,1.65-3.77,1.25-6.14,3.78-7.17,7.63.98-.14,4.45-.39,5.28-.39,1.24-2.47,2.03-4.07,4.94-4.07s3.69,1.56,4.94,4.03c.83,0,4.3.25,5.28.39-1.03-3.85-3.4-6.39-7.17-7.63-1.02-.34-1.22-.79-1.2-1.65.04-1.65.01-3.29.01-5.12,2.6,0,5.86,0,7.51,0,4.1,0,4.28-4.65.08-4.65Z",
    fill: "url(#gAlt)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.99,40.3s6.55.02,7.36,1.22v-9.56s-3.81-.77-5.7-.28-1.66,2.5-1.66,2.5v6.12Z",
    fill: "url(#hAlt)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.29,46.5h21.96c4.07,0,7.38,3.31,7.38,7.38v15.96h-36.72v-15.96c0-4.07,3.31-7.38,7.38-7.38Z",
    fill: "url(#iAlt)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.68,46.5h22.3c3.98,0,7.21,3.23,7.21,7.21v16.13h-36.72v-16.13c0-3.98,3.23-7.21,7.21-7.21Z",
    fill: "url(#jAlt)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.76,128.48c-3.45.2-6.91.41-10.36.62-.85.05-1.46-.1-1.84-.45-.38-.35-.57-.96-.57-1.8v-43.34c0-.85.19-1.46.57-1.84.38-.38.99-.57,1.84-.57h29.83c.85,0,1.46.18,1.84.55.38.36.57.95.57,1.76,0,2.54,0,5.09,0,7.63,0,.81-.19,1.4-.57,1.77-.38.37-.99.56-1.84.57-5.68.08-11.37.16-17.05.25,0,2.27,0,4.55,0,6.82,3.88-.09,7.76-.18,11.63-.26.85-.02,1.46.15,1.84.51.38.36.57.95.57,1.76,0,2.58,0,5.16,0,7.74,0,.82-.19,1.42-.57,1.79-.38.38-.99.58-1.84.61-3.88.14-7.75.29-11.63.44,0,4.31,0,8.62,0,12.93,0,.83-.19,1.44-.57,1.84-.38.39-.99.62-1.84.66Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6,125.59c-10.61.39-21.22.84-31.83,1.35-.85.04-1.46-.11-1.84-.45-.38-.34-.57-.92-.57-1.73,0-3.66,0-7.32,0-10.98,0-2.47.26-4.51.77-6.12.51-1.61,1.24-2.93,2.18-3.97.94-1.04,2.05-1.87,3.35-2.49,1.29-.62,2.7-1.15,4.21-1.6,2.99-.94,5.98-1.87,8.96-2.79.71-.18,1.19-.43,1.44-.77.24-.34.37-.84.37-1.51,0-.62-.13-1.05-.4-1.28-.27-.23-.74-.34-1.4-.33-4.84.05-9.67.11-14.51.17-.85.01-1.46-.16-1.84-.52-.38-.36-.57-.94-.57-1.74,0-2.48,0-4.97,0-7.45,0-.8.19-1.39.57-1.75.38-.36.99-.54,1.84-.54h19.73c3.79,0,6.7.88,8.73,2.63,2.03,1.75,3.04,4.28,3.04,7.61,0,1.93,0,3.87,0,5.8,0,3.08-.94,5.46-2.81,7.15-1.87,1.68-4.42,3.02-7.63,4.01-3.03.96-6.06,1.94-9.1,2.93-.67.19-1.13.39-1.37.6-.25.22-.37.66-.37,1.33,0,.44,0,.88,0,1.32,6.35-.2,12.71-.39,19.06-.56.85-.02,1.46.14,1.84.48.38.34.57.9.57,1.68,0,2.41,0,4.81,0,7.22,0,.78-.19,1.35-.57,1.72-.38.36-.99.56-1.84.59Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.47,124.84c-3.34.1-6.69.2-10.03.3-.85.03-1.46-.13-1.84-.46-.38-.33-.57-.89-.57-1.67,0-13.24.02-26.47.03-39.71,0-.77.19-1.34.57-1.69.38-.35.99-.52,1.84-.52h6.96c.85,0,1.57.12,2.17.36.6.24,1.19.67,1.77,1.27,4.32,4.49,8.64,8.94,12.97,13.36,0-4.28,0-8.56,0-12.83,0-.76.19-1.31.57-1.66.38-.34.99-.51,1.84-.51h10.03c.85,0,1.46.17,1.84.51.38.34.57.89.57,1.64,0,12.92-.01,25.84-.02,38.76,0,.76-.19,1.31-.57,1.66-.38.35-.99.53-1.84.54-3.35.06-6.69.13-10.04.21-.85.02-1.46-.14-1.84-.47-.38-.33-.57-.88-.57-1.64,0-2.47,0-4.94,0-7.41-3.81-4.09-7.62-8.19-11.43-12.33,0,6.67,0,13.34-.01,20.02,0,.77-.19,1.33-.57,1.68-.38.35-.99.54-1.84.57Z",
    fill: "url(#kAlt)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.75,123.76c-7.05.05-14.1.13-21.14.23-.85.01-1.46-.15-1.84-.48-.38-.33-.57-.88-.57-1.63,0-2.33,0-4.65,0-6.98,0-.75.19-1.3.57-1.65.38-.34.99-.52,1.84-.53,6-.06,12-.12,18-.15.58,0,1.01-.17,1.3-.51.29-.34.43-.74.44-1.22,0-.67-.14-1.16-.43-1.48-.29-.31-.72-.49-1.3-.53-3.34-.4-6.69-.79-10.03-1.18-3.12-.37-5.63-1.26-7.52-2.68-1.89-1.41-2.84-3.79-2.84-7.13,0-2.09,0-4.17,0-6.26,0-3.38,1.23-5.98,3.68-7.78,2.45-1.81,5.84-2.71,10.17-2.71h18.73c.85,0,1.46.17,1.84.5.38.34.57.88.57,1.63,0,2.35,0,4.69,0,7.04,0,.75-.19,1.29-.57,1.63-.38.34-.99.5-1.84.5-5.19,0-10.39.01-15.58.03-.58,0-1.03.17-1.34.51-.31.34-.47.76-.47,1.28,0,.52.16.95.47,1.3.31.36.76.55,1.34.59,3.32.38,6.64.77,9.97,1.16,3.12.39,5.64,1.29,7.56,2.71,1.92,1.42,2.88,3.78,2.88,7.1,0,2.07,0,4.14,0,6.21,0,3.35-1.24,5.93-3.71,7.73-2.48,1.8-5.86,2.72-10.14,2.75Z",
    fill: "url(#lAlt)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.23,123.69c-.85,0-1.46-.17-1.84-.5-.38-.33-.57-.88-.57-1.63v-7.04c0-.75.19-1.29.57-1.63.38-.33.99-.5,1.84-.5,2.21,0,4.42,0,6.62,0,0-6.63,0-13.26,0-19.88-2.21,0-4.41,0-6.62,0-.85,0-1.46-.17-1.84-.5-.38-.33-.57-.88-.57-1.63v-7.16c0-.75.19-1.29.57-1.63.38-.33.99-.5,1.84-.5h28.49c.85,0,1.46.17,1.84.5.38.34.57.88.57,1.63,0,2.4,0,4.79,0,7.19,0,.75-.19,1.3-.57,1.63-.38.34-.99.5-1.84.5-2.16,0-4.33-.01-6.49-.02,0,6.64,0,13.28,0,19.93,2.16.01,4.33.03,6.49.05.85,0,1.46.18,1.84.52.38.34.57.89.57,1.64,0,2.36,0,4.71,0,7.07,0,.75-.19,1.3-.57,1.63-.38.33-.99.49-1.84.48-9.5-.1-19-.16-28.5-.17Z",
    fill: "url(#mAlt)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M255.17,124.78c-7.02-.2-14.05-.36-21.07-.51-5.58-.11-9.71-1.18-12.41-3.21-2.7-2.03-4.05-5.1-4.05-9.23,0-6.19,0-12.39,0-18.58,0-4.13,1.34-7.18,4.04-9.17,2.7-1.98,6.83-2.98,12.4-2.98h16.72c.85,0,1.46.17,1.84.51.38.34.57.9.57,1.67,0,2.44,0,4.89,0,7.33,0,.77-.19,1.32-.57,1.66-.38.34-.99.51-1.84.5-4.64-.03-9.27-.06-13.91-.09-1.38,0-2.41.24-3.08.73-.67.5-1,1.24-1,2.24,0,4.77,0,9.55,0,14.32,0,1,.26,1.74.77,2.23.51.49,1.28.74,2.31.75,2.16.03,4.33.07,6.49.11,0-3.13,0-6.26,0-9.39,0-.76.19-1.31.57-1.65.38-.34.99-.5,1.84-.49,3.46.04,6.91.08,10.37.13.85.01,1.46.19,1.84.54.38.35.57.91.57,1.68,0,6.26,0,12.52.01,18.78,0,.77-.19,1.32-.57,1.65-.38.33-.99.49-1.84.46Z",
    fill: "url(#nAlt)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.51,125.52c-3.46-.12-6.91-.24-10.37-.35-.85-.03-1.46-.22-1.84-.58-.38-.36-.57-.92-.57-1.7,0-13.2-.02-26.4-.03-39.59,0-.77.19-1.33.57-1.68.38-.35.99-.52,1.84-.52h10.37c.85,0,1.46.18,1.84.53.38.35.57.92.57,1.7,0,4.47,0,8.94.01,13.42,3.72.05,7.45.1,11.17.15,0-4.52,0-9.03,0-13.55,0-.79.19-1.36.57-1.72.38-.35.99-.53,1.84-.53h10.37c.85,0,1.46.18,1.84.54.38.36.57.94.57,1.74,0,13.68.02,27.37.03,41.05,0,.8-.19,1.38-.57,1.72-.38.34-.99.49-1.84.45-3.45-.16-6.91-.31-10.36-.45-.85-.03-1.46-.24-1.84-.61-.38-.37-.57-.95-.57-1.74,0-4.62,0-9.24-.01-13.86-3.72-.1-7.45-.19-11.17-.28,0,4.58,0,9.15.01,13.73,0,.78-.19,1.34-.57,1.68-.38.34-.99.49-1.84.46Z",
    fill: "url(#oAlt)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M339.22,128.37c-3.61-.21-7.22-.41-10.83-.6-.85-.05-1.46-.26-1.84-.65-.38-.39-.57-.99-.57-1.81,0-10.58,0-21.16-.01-31.74-3.28-.05-6.55-.09-9.83-.13-.85-.01-1.46-.2-1.84-.57-.38-.37-.57-.95-.57-1.76,0-2.57,0-5.14,0-7.72,0-.81.19-1.39.57-1.75.38-.36.99-.54,1.84-.54h35.31c.85,0,1.46.19,1.84.57.38.38.57.99.57,1.84,0,2.7,0,5.4,0,8.09,0,.85-.19,1.46-.57,1.83-.38.37-.99.55-1.84.54-3.28-.05-6.55-.11-9.83-.16,0,10.78,0,21.55,0,32.33,0,.83-.19,1.43-.57,1.78-.38.35-.99.5-1.84.45Z",
    fill: "url(#pAlt)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2Nsight);
export default __webpack_public_path__ + "static/media/F2nsight.cd5d5965d0c44117cbeadc53256a16d2.svg";
export { ForwardRef as ReactComponent };